
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class DeleteIcon extends Vue {}
